module.exports = __webpack_public_path__ + "static/img/empty.ddf68a09.png";